import React, { useEffect, useState } from "react";
import { Event } from "./HomeTrainer";
import { Link, useLocation } from "react-router-dom";
import styles from "./Home.module.scss";
import StudentItems from "../components/StudentItems";

const HomeStudent = () => {
	const [events, setEvents] = useState<Event[]>([]);
	const [errorMessage, setErrorMessage] = useState<string | null>(null);
	const [isClassChanged, setIsClassChanged] = useState(false);

	function compareEvents(event1: Event, event2: Event): number {
		const startTime1 = new Date(event1.start.dateTime).getTime();
		const startTime2 = new Date(event2.start.dateTime).getTime();

		if (startTime1 < startTime2) {
			return -1; // event1 を event2 より前に表示
		} else if (startTime1 > startTime2) {
			return 1; // event1 を event2 より後に表示
		} else {
			return 0; // 開始時刻が同じ場合は順序を変更しない
		}
	}

	useEffect(() => {
		// 一般公開カレンダーのIDとAPIキー
		const CALENDAR_ID = "vei0b76lgidkspnj1mj8pqn1u4@group.calendar.google.com"; // カレンダーのIDをここに設定
		const API_KEY = "AIzaSyB06ZG5Dckp2M5poGEtHlCYLqQwsUwH7Qk"; // ここにAPIキーを設定

		// 今日の日付を取得
		const today = new Date();
		// 今日の日付の始まりの時刻を設定（00:00:00）
		const todayStart = new Date(today);
		todayStart.setHours(0, 0, 0, 0);

		// 今日の日付の終わりの時刻を設定（23:59:59）
		const todayEnd = new Date(today);
		todayEnd.setHours(23, 59, 59, 999);

		// Google Calendar APIエンドポイント
		const apiUrl = `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events?key=${API_KEY}&timeMin=${todayStart.toISOString()}&timeMax=${todayEnd.toISOString()}&singleEvents=true`;

		// イベントを取得する関数
		async function getEvents() {
			try {
				const response = await fetch(apiUrl);

				if (!response) {
					throw new Error("APIからの応答がありません。");
				}

				if (response.status === 200) {
					const data: { items: Event[] } = await response.json();
					const events = data.items || [];
					events.sort(compareEvents);
					setEvents(events);
				} else {
					console.error(`APIエラー: ${response.status}`);
					setErrorMessage(`APIエラー: ${response.status}`); // エラーがある場合、エラーステートを更新
				}
			} catch (errorMessage: any) {
				console.error("エラー:", errorMessage.message);
				setErrorMessage(`エラー: ${errorMessage.message}`); // エラーがある場合、エラーステートを更新
			}
		}

		getEvents();
	}, []);

	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const pass = process.env.REACT_APP_SECRET_PASSWORD_STUDENT;
	if (pass !== "") {
		const paramValue = queryParams.get("pass");
		if (pass !== paramValue) {
			return <>パスワードが違います。</>;
		}
	}

	return (
		<main className={`${styles.inner} ${styles.student}`}>
			<h1 className={styles.pageTitle}>出勤トレーナー一覧</h1>
			{errorMessage ? (
				<p>{errorMessage}</p>
			) : (
				<>
					<div
						className={`${styles.trainerList} ${
							isClassChanged ? styles.change : ""
						}`}
					>
						{events.map((event) => {
							const allowedStrings = [
								"寺越真知子",
								"大沢臣爾",
								"齋藤りり子",
								"関聖二",
								"杉野舞",
								"五十嵐渉",
								"鈴木美佳",
								"市村洋隆",
								"白戸智真",
								"田中克幸",
								"田中克幸[リモ]",
							];
							const containsAllowedString = allowedStrings.some((str) =>
								event.summary.includes(str)
							);

							if (!containsAllowedString) {
								return null;
							}
							return <StudentItems key={event.id} event={event} />;
						})}
					</div>
					<button
						className={styles.secret}
						onClick={() => setIsClassChanged(!isClassChanged)}
					>
						？
					</button>
					<div className={styles.toAll}>
						<Link to="/alltrainer">
							スタッフ
							<br />
							トレーナー
							<br />
							一覧
						</Link>
					</div>
				</>
			)}
		</main>
	);
};

export default HomeStudent;
